<template>
  <div class="row">
    <div class="col-12">
      <ibox :title="'Przymierzalnia'">
        <!-- <template slot="tools">
          <router-link
            :to="`/przymierzalnia/${$route.params.env}/banner/dodaj`"
            class="btn btn-primary btn-xs"
          >
            Dodaj nowy Produkt
            <i class="fas fa-plus"></i>
          </router-link>
        </template> -->
        <template slot="content" slot-scope="{ setLoading }">
          <data-tables
            ref="productsTable"
            :url="`vnfr/${$route.params.env}/banners/list`"
            :columns_list="columns_list"
            @loading="setLoading"
          />
        </template>
      </ibox>
    </div>
  </div>
</template>

<script>
import Ibox from '@/components/Ibox'
import DataTables from '@/components/DataTables'

export default {
  name: 'ProductsList',
  components: {
    Ibox,
    DataTables
  },
  computed: {
    sortProductsUrl() {
      return `vnfr/${this.$route.params.env}/products/sort`
    }
  },
  data() {
    return {
      excel: true,
      draggableSort: true,
      columns_list: [
        {
          key: 'id',
          name: this.$t( 'edit' ),
          filter: 'btn',
          btn: a =>
            `<a href="#/przymierzalnia/${this.$route.params.env}/banners/${a}"><i class="fa fa-edit"></i></a>`
        },
        {
          key: 'image_url',
          name: 'Plum',
          filter: 'image',
          width: '250',
          sortable: true
        },
        {
          key: 'lang',
          name: 'Język',
          type: 'text',
          sortable: true
        },
        {
          key: 'categories_lang',
          name: 'Kategoria',
          type: 'text',
          sortable: true
        },
        {
          key: 'parameters_lang',
          name: 'Parametr',
          type: 'text',
          sortable: true
        }
      ]
    }
  }
}
</script>
